/// \file redirect.ts
///
/// \par Copyright Notice:
/// Copyright (c) 2024 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

const Redirect = (to:string,navigate:any) => {
    const nav = navigate
    const Redirector = () => {
        nav(to);
    }
    Redirector()
}

export default Redirect;
